export const color={
    main:"#EC9C99",
    dark:"#D83630",
    light:"#FFF5F5",
}